import { useEffect } from 'react';

import { useAppSelector } from '@/store/hooks';
import { logger } from '@/services/logger/logger';

import { JourneyName } from './types';

function JourneyContainer({ children, journey }: React.PropsWithChildren<{ journey: JourneyName }>) {
  const selectedJourney = useAppSelector(state => state.journeys.journey);

  useEffect(() => {
    // Log when selectedJourney (in state) does not match the route journey
    if (journey !== selectedJourney && !!selectedJourney) {
      logger.error(
        `Accessing incorrect journey: journey="${journey}" selectedJourney="${selectedJourney}"`
      );
    }
  }, [journey, selectedJourney]);

  return children;
}

export default JourneyContainer;
